import type { notificationQuerySchema } from "@spare-cart/contracts/notifications";
import type { z } from "@spare-cart/contracts/common";

export const notificationKeys = {
  all: ["notifications"] as const,
  lists: () => [...notificationKeys.all, "list"] as const,
  list: (query: z.input<typeof notificationQuerySchema>) =>
    [...notificationKeys.lists(), query] as const,
  unreadCount: () => [...notificationKeys.all, "unread-count"] as const,
};
